import { render } from "./CategoryPost.vue?vue&type=template&id=7f00ae94"
import script from "./CategoryPost.vue?vue&type=script&lang=js"
export * from "./CategoryPost.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__